/// <amd-module name="Artifacts/Root/routing/RootRouter" />

import {
  connectToFeedRoutes,
  feedHubRedirectorContainerName,
  feedHubRoutes,
  feedSettingsRoutes,
  packageDetailsRouter,
  packageRecycleBinRoutes,
} from "Artifacts/Root/routing/Definitions";
import { useLegacyRedirection } from "Artifacts/Root/routing/Hooks";
import { asLazyContainerComponent } from "Artifacts/Root/routing/Tools";
import { createBrowserHistory } from "history";
import * as React from "react";
import { useState } from "react";
import { Redirect, Route, RouteProps, Router, Switch } from "react-router-dom";
import { ITfsPageData } from "Tfs/Platform/Page";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { routeUrl } from "VSS/Platform/Location";
export interface IRootRouterProps {
  pageContext: IVssPageContext;
}

function flattenRoutes(subroutes: RouteProps[][]): RouteProps[] {
  let routes: RouteProps[] = [];
  for (const route of subroutes) {
    routes = [...routes, ...route];
  }
  return routes;
}

function getRoutes(): RouteProps[] {
  return [
    {
      path: "/",
      exact: true,
      component: asLazyContainerComponent(feedHubRedirectorContainerName),
    },
    ...flattenRoutes([
      packageRecycleBinRoutes,
      connectToFeedRoutes,
      feedSettingsRoutes,
      packageDetailsRouter,
      feedHubRoutes,
    ]),
  ];
}

const RootRouter: React.FC<IRootRouterProps> = ({ pageContext }) => {
  const basename = React.useMemo(() => {
    const contributionService = pageContext.getService<IVssContributionService>(
      "IVssContributionService",
    );
    const tfsPageData = contributionService.getData<ITfsPageData>("ms.vss-tfs-web.page-data");
    const projectName = tfsPageData?.project?.name as string;
    return routeUrl(pageContext, "ms.azure-artifacts.artifacts-route", { project: projectName });
  }, [pageContext]);

  const [routes] = useState<RouteProps[]>(() => getRoutes());
  const [history] = useState(() => createBrowserHistory({ basename }));

  const redirectRoute = useLegacyRedirection();

  return (
    <Router history={history}>
      {/* <Redirect> can be used with a from property inside a <Switch> element with regex matching
          but it does not work with query parameters. So we need to work around that by redirecting
          only if there is a route to redirect to. */}
      {redirectRoute && <Redirect to={redirectRoute} />}
      <Switch>
        {routes.map((route, index) => (
          <Route key={index} {...route} />
        ))}
      </Switch>
    </Router>
  );
};

export { RootRouter, getRoutes };
